import CONSTANTS from '../constants'
import { isLoggedIn } from '../../utils/helper'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

const INITIAL_STATE = {
    loader: false,
    isUserLogin: isLoggedIn(),
    isAuthenticated: false,
    hasError: false,
    data: EMPTY_OBJECT,
    email: null,
    role: null,
    errorMessage: '',
    id: null,
    orgId: ''
}

const citationReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        //LOGIN HANDLING
        case CONSTANTS.POST_CITATION_CARD_REQUEST:
            return {
                ...state,
                loader: true,
                errorMessage: ''
            }
        case CONSTANTS.POST_CITATION_CARD_SUCCESS:
            return {
                ...state,
                loader: false,
                data: action.data,
                isAuthenticated: true,
                hasError: false,
                errorMessage: ''
            }
        case CONSTANTS.POST_CITATION_CARD_FAILURE:
            return {
                ...state,
                loader: false,
                errorMessage: 'There is some Error'
            }

        // GET CITATION DETAILS
        case CONSTANTS.GET_CITATION_DETAILS_REQUEST:
            return {
                ...state,
                loader: true,
                errorMessage: ''
            }
        case CONSTANTS.GET_CITATION_DETAILS_SUCCESS:
            return {
                ...state,
                loader: false,
                citationData: action.data,
                isAuthenticated: true,
                hasError: false,
                errorMessage: ''
            }
        case CONSTANTS.GET_CITATION_DETAILS_FAILURE:
            return {
                ...state,
                loader: false,
                errorMessage: 'There is some Error'
            }

             // GET CITATION After Payment
        case CONSTANTS.AFTER_PASS_PAYMENT_INITIAL_REQUEST:
            return {
                ...state,
                loader: true,
                errorMessage: ''
            }
        case CONSTANTS.AFTER_PASS_PAYMENT_INITIAL_SUCCESS:
            return {
                ...state,
                loader: false,
                citationData: action.data,
                isAuthenticated: true,
                hasError: false,
                errorMessage: ''
            }
        case CONSTANTS.AFTER_PASS_PAYMENT_INITIAL_FAILURE:
            return {
                ...state,
                loader: false,
                errorMessage: 'There is some Error'
            }

        default:
            return state
    }
}

export default citationReducer
